"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStateSnapshotSample = exports.getStateSample = void 0;
const math_1 = require("../math");
const getStateSample = (keyRangeMap) => {
    const res = Object.fromEntries(Object.entries(keyRangeMap).map(([k, v]) => [k, (0, math_1.randn_bm)(v.min, v.max, v.skew)]));
    return res;
};
exports.getStateSample = getStateSample;
const getStateSnapshotSample = (timestamp, keyRangeMap) => ({ timestamp, state: (0, exports.getStateSample)(keyRangeMap) });
exports.getStateSnapshotSample = getStateSnapshotSample;
